import { useState, useCallback } from 'react'
import { getCampaignReport } from '../../mailTemplate/src/services/B2BServices'
import { useToast } from './useToast'

export const useCampaignReports = (t) => {
  const { showError } = useToast()

  const [campaignReportsFetching, setCampaignReportsFetching] = useState({})

  const setCampaignReportFetchingStatus = useCallback((b2bCampaignId, fetching = false) => {
    setCampaignReportsFetching(prevState => ({
      ...prevState,
      [b2bCampaignId]: fetching
    }))
  }, [])

  const refreshCampaignReport = useCallback(async (b2bCampaignId, setCampaignReports) => {
    if (!b2bCampaignId) return

    setCampaignReportFetchingStatus(b2bCampaignId, true)

    const minDelay = new Promise(resolve => setTimeout(resolve, 200))

    try {
      const [res] = await Promise.all([
        getCampaignReport(b2bCampaignId),
        minDelay
      ])
      setCampaignReports(prevState => ({
        ...prevState,
        [b2bCampaignId]: res.data
      }))
    } catch (err) {
      showError(err || t('mailTemplate.campaignReport.fetchErr'))
    } finally {
      setCampaignReportFetchingStatus(b2bCampaignId, false)
    }
  }, [setCampaignReportFetchingStatus, showError, t])

  return {
    campaignReportsFetching,
    refreshCampaignReport,
    setCampaignReportFetchingStatus
  }
}
